import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { SetUserBlockedStateParams } from 'types/services';

export const setUserBlockedState = async (
  params: SetUserBlockedStateParams
) => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
